/** A value that follows `value` only once it has held still for `ms`.
 *
 * Used where every change fires a request that is expensive to answer: clicking through six dates in the replay simulator used to
 * start six Athena loads (70-235 s each once they queued); with this the page asks only for the date it stops on. */

import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, ms: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setSettled(value);
    }, ms);
    return () => {
      clearTimeout(timer);
    };
  }, [value, ms]);
  return settled;
}
